﻿$.fn.dxCtrlBoxPublicDossierExterne = function custom_dxCtrlBoxPublicDossierExterne(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlboxpublicdossierexterne dx-ctrl");
        this.createInstance(new cdxCtrlBoxPublicDossierExterne(this, option));
    }
    return this;
}

window.cdxCtrlBoxPublicDossierExterne = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var pathSource = option.path
    var popupContent = null
    function mConstruit() {
        container.empty()

        var popup = container.appendTo("body").dxCtrlPopupBase({
            showMaximize: false,
            height: "100%",
            width: "100%",
            hideOnOutsideClick: false,
            shading: true,
            showTitle: false,
            title: option.title,
            //showCloseButton: false,
            contentTemplate: function (contentElement) {
                contentElement.css("padding", "0")
                popupContent = contentElement
                mRempliContent()
            }
        }).dxCtrlPopupBase("instance")
        popup.show()

    }

    function mGetPathRacine() {
        var pathResult = option.path.replace(pathSource, "")
        if (pathResult.endsWith("/")) pathResult = pathResult.substring(0, pathResult.length - 1)
        return pathResult
    }

    function mRempliContent() {
        popupContent.empty()
        var $DivHeader = $("<div style='padding:10px;font-size:200%;'/>").appendTo(popupContent)
        var fichier = new cFichier(option.bddCtrl, option.path)
        $DivHeader.html("<span>/" + mGetPathRacine() + "</span>")
        if (option.path != pathSource) {
            var $I = $("<i class='fas fa-circle-arrow-left state-hover' style='padding:5px;border-radius:50%;'></i>").appendTo($DivHeader)
            $I.attr("title", "Revenir vers en arrière")
            $I.on("click", function (e) {
                var parentPath = option.path.substring(0, option.path.length - 1)
                parentPath = parentPath.substring(0, parentPath.lastIndexOf("/") + 1)
                option.path = parentPath
                mRempliContent()
            })
        }
        var $DivEntete = $("<div style='border:" + theme.border + ";padding:0 20%;'/>").appendTo(popupContent)
        var $DivFooter = $("<div style='text-align:right;padding:5px 10px 0px 10px;'/>").appendTo(popupContent)
        $("<div style='display:inline-block;'/>").appendTo($DivFooter).dxCtrlPiedTitleApp({
            bddCtrl:option.bddCtrl,
            widthImg: 30,
            fontSize: "130%",
            ssFontSize: "65%",
            type:8
        }).find("table").css({ "padding": "0", "margin": "0" })
        resizeObserver.mAdd([$DivHeader, $DivFooter], function () { $DivEntete.css("height", "calc(100% - " + ($DivFooter.innerHeight() + $DivHeader.innerHeight()) + "px)"); })()

        if (!option.path.contains("/documents_publics/")) {
            //on ne travaille pas sur le répertoire public
            $DivEntete.css({
                display: "flex",
                "justify-content": "center",
                "align-items": "center"
            })
            $("<div/>").appendTo($DivEntete).text("Vous n'avez pas accés à ce répertoire.")
        } else {
            option.bddCtrl.mAjaxCall({
                command: "loaddatagrid",
                path: option.path,
                type_data: "fichier",
                field_group_sort: JSON.parse('[{"field":{"name":"nom","dataField":"nom","caption":"Nom","icon":"fas fa-file","allowFilter":true,"allowGrid":true,"allowGrouping":false,"allowSorting":true,"dataType":"string"},"sortIndex":0,"sortOrder":"asc"}]'),
                filters: {
                    lstFilter: [[]]
                },
                txt_search_lucene: ""
            }, function (data) {
                if (!data.lstdata) data.lstdata = []
                if (data.lstdata.length == 0) {
                    $DivEntete.css({
                        display: "flex",
                        "justify-content": "center",
                        "align-items": "center"
                    })
                    $("<div/>").appendTo($DivEntete).text("Aucun fichier dans ce répertoire.")
                } else {
                    var dxScroll = $("<div/>").appendTo($DivEntete).dxScrollView({}).dxScrollView("instance")
                    //rempli dossier
                    data.lstdata.filter(function (o) { return o.id.endsWith("/") }).forEach(function (itemData) {
                        mRempliItem(itemData, dxScroll.content())
                    })
                    //rempli fichier
                    data.lstdata.filter(function (o) { return !o.id.endsWith("/") }).forEach(function (itemData) {
                        mRempliItem(itemData, dxScroll.content())
                    })
                }
            })
        }
    }

    function mRempliItem(itemData, contentElement) {
        //var dossier = {
        //    "id_fichier": "~/fichier/masc_aagest/documents_publics/test/",
        //    "dcr": "2026-09-24T04:41:12.716Z",
        //    "dmo": "2026-09-24T04:41:12.716Z",
        //    "id_table": 0,
        //    "id": "~/fichier/masc_aagest/documents_publics/test/",
        //    "nom": "test",
        //    "extension": "",
        //    "taille_octet": 0,
        //    "rownum": 1,
        //    "cle": "~/fichier/masc_aagest/documents_publics/test/_0"
        //}
        //var fichier = {
        //    "dcr": "2026-09-21T20:47:58.779Z",
        //    "dmo": "2026-09-21T20:47:58.779Z",
        //    "id_table": 0,
        //    "id": "~/fichier/masc_aagest/documents_publics/mascaron200_compress.png",
        //    "nom": "mascaron200_compress.png",
        //    "extension": ".png",
        //    "taille_octet": 3124,
        //    "rownum": 2,
        //    "cle": "~/fichier/masc_aagest/documents_publics/mascaron200_compress.png_0"
        //}
        var $DivContent = $("<div style='margin:10px;padding:5px;border:" + theme.border + ";-webkit-box-shadow: 0 0 5px 0.5px rgba(0, 0, 0,0.5);-moz-box-shadow: 0 0 5px 0.5px rgba(0, 0, 0,0.5);box-shadow: 0 0 5px 0.5px rgba(0, 0, 0,0.5);' class='state-hover'/>").appendTo(contentElement)
        $DivContent.on("click", function (e) {
            if (fichier.isDirectory) {
                option.path = itemData.id
                mRempliContent()
            } else {
                window.open(fichier.urlPublicAbsolue(),"_blank")
            }
        })
        var $Table = $("<table style='width:100%;table-layout:fixed;height:40px'/>").appendTo($DivContent)
        var $Tr = $("<tr/>").appendTo($Table)
        var fichier = new cFichier(option.bddCtrl, itemData.id, itemData.taille_octet, itemData.dcr, itemData.dmo)

        var $Td = $("<td style='width:60px;font-size:31px;'/>").appendTo($Tr)
        fichier.mGetElementImage(40, 40).appendTo($Td)

        var $Td = $("<td style='width:100%;overflow:hidden;text-overflow:ellipsis;white-space;nowrap;'/>").appendTo($Tr)
        $("<span/>").text(fichier.mGetLib1()).appendTo($Td)
        if (mGetPathDoc().length > 1) {
            $("<span/>").html(" &bull; ").appendTo($Td)
            $("<span style='opacity:0.5;'/>").text(mGetPathDoc()).appendTo($Td)
        }

        var $Td = $("<td style='width:70px;'/>").appendTo($Tr)
        if (typeof itemData.taille_octet != 'undefined' && !fichier.isDirectory) {
            $Td.text(itemData.taille_octet.sizeFile())
        }

        function mGetPathDoc() {
            if (fichier.isDirectory) {
                var path = fichier.mGetPath().replace(pathSource, "")
                return "/" + path.substring(0,path.lastIndexOf("/"))
            } else {
                var path = "/" + (fichier.mGetPath() + "/").replace(pathSource, "")
                if (path.endsWith("/")) path = path.substring(0, path.length - 1)
                return path
            }
        }
    }

    this.element = function () { return container }

    mConstruit();
}